import React, { Component } from "react";
import { connect } from "react-redux";
import { updateTheme } from "../actions/themeEditor_actions";

const ThemeEditorContainer = WrappedComponent => {
    class ThemeEditorContainer extends Component {
        render() {
            const { theme, updateTheme } = this.props;
            if (!theme.colors) {
                return null;
            }
            return <WrappedComponent theme={theme} update={updateTheme} />;
        }
    }
    const mapStateToProps = ({ theme }) => {
        return {
            theme: theme.attributes
        };
    };
    return connect(
        mapStateToProps,
        { updateTheme }
    )(ThemeEditorContainer);
};

export default ThemeEditorContainer;
